import { makeStyles } from "@material-ui/core";
import { instance4 } from "App/constants";

export const urlGetFA = "/wmsAsset/asset/list";

export const STYLE_FA_TFA = makeStyles({
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
});

export const headCellsTF = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: false,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA ASSET",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "code",
    disablePadding: false,
    label: "CODE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "merek",
    disablePadding: false,
    label: "MERK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "type",
    disablePadding: false,
    label: "TYPE",
    align: "left",
    minWidth: "150px",
  },
];

export const RESET_STATE_FORM_FILTER_DATA = {
  search: "",
  halaman: 1,
  jumlah: 10,
};


export const getByFilterFA = async (formFilter, pages, limit, idGudang) => {
  try {
    const api = await instance4.post(urlGetFA, {
      status_kelengkapan: 1,
      status: true,
      pembelian_id: "",
      supplier_id: "",
      gudang_id: idGudang,
      produsen_id: "",
      search: formFilter.search,
      tglAwal: "",
      tglAkhir: "",
      pages: pages,
      limit: limit,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
        meta: {
          count: parseInt(res.meta.count),
          pages: parseInt(res.meta.pages),
          limit: parseInt(res.meta.limit),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};
